class ProductBuyButtons extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.button_container = this.querySelector(
      ".product-buy-buttons--primary"
    )),
      (this.button_text = this.querySelector(".product-buy-buttons--cta-text")),
      (this.form = this.querySelector(".product-buy-buttons--form")),
      (this.select_input = this.querySelector(".product-buy-buttons--select")),
      (this.smart_button = this.querySelector(".product-buy-buttons--smart")),
      (this.primary_button = this.querySelector(".product-buy-buttons--cta")),
      this.addToCartListener(),
      this.updateViewListener();
  }
 addToCartListener() {
  this.form.addEventListener("submit", async (t) => {
    t.preventDefault();
    t.stopPropagation();

    const form = t.target;
    const available = theme.utils.getAvailableQuantity(form);

    if (!available) return;

    this.button_container.setAttribute("data-loading", true);

    try {
      const item = await theme.cart.addItem(form);

      if (item) {
        // IMPORTANTE: no llamamos a updateAllHtml ni a addProductComplete
        this.button_container.setAttribute("data-loading", false);
      }
    } catch (error) {
      console.error("Error al agregar al carrito", error);
      this.button_container.setAttribute("data-loading", false);
    }
  });
}
  addProductComplete() {
    theme.off_canvas.toggleView("cart"),
      "closed" === theme.off_canvas.state &&
        (theme.off_canvas.openRight(),
        (theme.off_canvas.last_trigger = this.primary_button));
  }
  updateViewListener() {
    window.on(
      `theme:product:${this.dataset.id}:variantChanged`,
      ({ detail: { variant: t } }) => {
        var e = this.select_input.querySelector("option[selected]");
        e && e.removeAttribute("selected"),
          t && t.available
            ? (this.selectVariant(t.id), this.updateView(!0, !0))
            : t && !t.available
            ? (this.selectVariant(t.id), this.updateView(!1, !0))
            : this.updateView(!1, !1);
      }
    );
  }
  selectVariant(t) {
    var e = this.select_input.querySelector(`option[value='${t}']`);
    e && e.setAttribute("selected", !0);
  }
  updateView(t, e) {
    t
      ? (this.primary_button.removeAttribute("disabled"),
//comenté esto para que no cambie el texto del botón al cambiar la variante.
       // (this.button_text.innerText = theme.translations.add_to_cart),
        this.smart_button && (this.smart_button.style.display = "block"))
      : (this.primary_button.setAttribute("disabled", !0),
        this.smart_button && (this.smart_button.style.display = "none"),
        (this.button_text.innerText = e
          ? theme.translations.out_of_stock
          : theme.translations.unavailable));
  }
}
const productBuyButtonsEl = customElements.get("product-buy-buttons-root");
productBuyButtonsEl ||
  customElements.define("product-buy-buttons-root", ProductBuyButtons);

